module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.afa7a91.ttf";